module.exports = __webpack_public_path__ + "img/PlaceImpact-min.9fea131c.jpg";